// The link to a business's Google Business Profile (its Google Maps listing).
// Returns "" when there is nothing real to link to; callers decide whether a
// Maps *search* is an acceptable fallback (this never invents one).

type Src = {
  gbp_url?: string | null;
  research_json?: string | null;
  mapsUri?: string | null;
  placeId?: string | null;
  name?: string | null;
};

const isHttp = (v: unknown): v is string => typeof v === "string" && /^https?:\/\//i.test(v.trim());

export function placeUrl(placeId: string, name?: string | null): string {
  const q = (name ?? "").trim() || "Google Maps";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}&query_place_id=${encodeURIComponent(placeId)}`;
}

export function gbpUrl(s: Src): string {
  if (isHttp(s.gbp_url)) return s.gbp_url.trim();
  let placeId = typeof s.placeId === "string" ? s.placeId.trim() : "";
  if (s.research_json) {
    try {
      const r = JSON.parse(s.research_json);
      const uri = r?.google_maps_uri ?? r?.gbp?.maps_uri;
      if (isHttp(uri)) return uri.trim();
      if (!placeId && typeof r?.google_place_id === "string") placeId = r.google_place_id.trim();
    } catch { /* malformed research blob: ignore */ }
  }
  if (isHttp(s.mapsUri)) return s.mapsUri.trim();
  return placeId ? placeUrl(placeId, s.name) : "";
}
